import * as Models from "../../../Models";
import * as UserManagementApiClient from './UserManagementApiClientService';
import * as UserManagement from "../";

    export interface IUserRetrievalService {
        searchUsers(request: UserManagement.models.UserSearchRequest.UserSearchRequest): ng.IPromise<UserManagement.models.UserSearchResult.IUserSearchResult[]>;
        getUser(id: string): ng.IPromise<Models.UserModel.IUserModel>;
        getUserByEmail(request: UserManagement.models.UserSearchRequest.UserSearchRequest): ng.IPromise<Models.UserModel.IUserModel>;
        getUsersInGroup(groupId: string): ng.IPromise<UserManagement.models.UsernameResult.IUsernameResult[]>;
        getUsersInPartner(partnerCode: string): ng.IPromise<UserManagement.models.UserSearchResult.IUserSearchResult[]>;
        searchUsernames(username: string): ng.IPromise<UserManagement.models.UsernameResult.IUsernameResult[]>;
        createUser(createUserRequest: UserManagement.models.CreateUserRequest.ICreateUserRequest): ng.IPromise<Models.Response.Response>;
    }

    export class UserRetrievalService implements IUserRetrievalService {
        public static $inject = ['UserManagementApiClientService'];

        constructor(private userManagementApiClientService: UserManagementApiClient.IUserManagementApiClientService) {
        }

        public searchUsers = (request: UserManagement.models.UserSearchRequest.UserSearchRequest) => {
            return this.userManagementApiClientService.searchUsers(request);
        }

        public createUser = (createUserRequest: UserManagement.models.CreateUserRequest.ICreateUserRequest): ng.IPromise<Models.Response.Response> => {
            return this.userManagementApiClientService.createUser(createUserRequest);
        }

        public getUser = (id: string) => {
            return this.userManagementApiClientService.getUserById(id);
        }

        public getUserByEmail = (request: UserManagement.models.UserSearchRequest.UserSearchRequest) => {
            return this.userManagementApiClientService.getUserByEmail(request);
        }

        public getUsersInGroup = (groupId: string) => {
            return this.userManagementApiClientService.getUsersInGroup(groupId);
        }

        public getUsersInPartner = (partnerCode: string) => {
            return this.userManagementApiClientService.getUsersInPartner(partnerCode);
        }

        public searchUsernames = (username: string) => {
            return this.userManagementApiClientService.getUsernames(username);
        }
    }